import { useUploadToBucket } from '../helpers/upload-to-bucket'
import { useClient } from '../supabase/client'

import { useMutation, useQueryClient } from '@tanstack/vue-query'
import type { MutationOptions } from '@xleddyl/types'

type Props = {
   file: File
   organizationId: string
}

export const useUpdateOrganizationPropic = (options?: MutationOptions) => {
   const client = useClient()
   const notification = useNotification()
   const uploadToBucket = useUploadToBucket()
   const qc = useQueryClient()

   const { t } = useI18n()

   return useMutation({
      onSuccess: (_, variables) => {
         notification?.add({
            type: 'success',
            title: t('info.success'),
            description: t('info.propic-updated'),
         })
      },
      onMutate: async () => {
         await qc.getDefaultOptions().mutations?.onMutate?.(options)
      },
      mutationFn: async (props: Props) => {
         const url = await uploadToBucket.mutateAsync({
            path: `public-files/organizations/${props.organizationId}/propic`,
            objects: props.file,
         })

         await client
            .schema('dashboard')
            .rpc('update_organization_propic', {
               p_propic_url: url[0],
               p_organization_id: props.organizationId,
            })
            .throwOnError()

         await qc.refetchQueries({ queryKey: ['organization', { id: props.organizationId }] })
      },
   })
}
